<template>
	<v-container fluid class="height-100">
		<v-card elevation="0" class="height-100">
			<v-card-title style="height: 72px">
				<v-icon class="mr-2" color="blue">mdi-police-badge-outline</v-icon>
				服务资质
				<v-spacer />
				<!-- <v-btn @click="add" class="success float-right mt-1" elevation="0"><v-icon>mdi-plus</v-icon>申请资质</v-btn> -->
			</v-card-title>
			<v-card-title class="pt-0">
				<v-btn-toggle v-model="queryParam.state" @change="searchQuery" color="primary" mandatory dense group class="ml-n2">
					<v-btn :value="item.key" class="ml-2" v-for="(item, index) in btnGroup" :key="index">{{ item.val }}</v-btn>
				</v-btn-toggle>
				<v-spacer />
				<v-text-field v-model="queryParam.condition" @change="searchQuery" @click:append="searchQuery" style="max-width: 380px" placeholder="请输入资质名称查询" outlined dense hide-details append-icon="mdi-magnify"></v-text-field>
			</v-card-title>
			<v-divider class="mx-4" />
			<v-card-text class="pt-0">
				<v-data-table @click:row="toView" :headers="headers" :items="desserts" :loading="loading" disable-pagination loading-text="数据加载中..." class="elevation-0 vtk-cursor-pointer" hide-default-footer>
					<template v-slot:[`item.first_col`]="{ item }">
						<span>{{ desserts.indexOf(item) + 1 }}</span>
					</template>
					<template v-slot:[`item.projName`]="{ item }">
						<v-hover v-slot="{ hover }">
							<v-list-item class="pl-0" style="max-width: 50vw">
								<v-list-item-avatar size="56" class=" rounded">
									<v-img :class="item.roleState | dict('0:gray_50/1:gray_0/2:gray_75')" :style="hover ? 'filter: grayscale(0%)' : ''" class="rounded-lg mx-auto gray" :src="item.projIcon" max-height="140" max-width="140"></v-img>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title>
										<v-chip class="mr-2" :class="item.areaCode.length | dict('1:green lighten-5  green--text/2:blue lighten-5  blue--text/4:cyan lighten-5  cyan--text/6:orange lighten-5  orange--text')" small label>
											{{ item.areaCode.length | dict("0:国家/2:省级/4:市级/6:区县") }}
										</v-chip>
										<v-chip class="teal lighten-5 teal--text mr-2" small label>
											{{ item.bizName }}
										</v-chip>
										{{ item.projName }}
										
									</v-list-item-title>
									<v-list-item-subtitle class="caption mt-2">
										{{ item.projNote }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-hover>
					</template>
					<template v-slot:[`item.actions`]="{ item }">
						<div :class="item.roleState | dict('0:serve_sqz/1:serve_yhd/2:serve_bjj')" style="height: 72px; width: 72px"></div>
					</template>
					<template v-slot:no-data>
						<v-card class="px-6 pt-4 pb-4 mt-3" elevation="0" id="train">
							<p class="grey--text mt-4">暂无数据</p>
						</v-card>
					</template>
				</v-data-table>
				<v-divider />
				<pagination :page-sizes="[10, 20]" :page-data="pageData" @pageChange="getListPage" />
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import Storage from "@/commons/storage";
import Mixins from "@/compositions/mixins/minxs";
import pagination from "@/components/pagination";
export default {
	name: "DashUrole",
	mixins: [Mixins],
	components: { pagination },
	data() {
		return {
			desserts: [],
			url: { list: "view/urole/page" },
			headers: [
				// { text: "序号", value: "first_col", sortable: false, width: 60, align: "center" },
				{ text: "资质", value: "projName", sortable: false },
				{ text: "状态", value: "actions", sortable: false, width: 72 },
				// { text: "操作", value: "actions", sortable: false, width: 110 },
			],
			btnGroup: [
				{ key: "A", val: "全部" },
				{ key: "Y", val: "已获得" },
				{ key: "N", val: "申请中" },
			],
			queryParam: { state: "A" },
		};
	},
	mounted() {
		this.queryParam.did = Storage.get("_wit_acis_users").did;
		this.loadPage();
	},
	methods: {
		toView(item) {
			this.$router.push({ path: "/dept-roles", query: { pid: item.id } });
		},
	},
};
</script>

<style lang="scss" scoped>
.border-dashed {
	border: 1px #2196f3 dashed;
}
.border-solid {
	border: 1px rgba(182, 182, 182, 0.6) solid;
}
::v-deep .v-banner--single-line .v-banner__wrapper {
	padding: 0 !important;
}
.gray {
	filter: grayscale(100%);
}
.gray_75 {
	filter: hue-rotate(140deg);
}
.gray_50 {
	filter: hue-rotate(205deg);
}
.gray_0 {
	filter: grayscale(0%);
}
.serve_yhd {
	background: url(../../assets/img/yhd.png) no-repeat;
	background-size: contain;
	background-position: calc(100% + 12px) calc(100% + 18px);
}
.serve_sqz {
	background: url(../../assets/img/sqz.png) no-repeat;
	background-size: contain;
	background-position: calc(100% + 12px) calc(100% + 18px);
}
.serve_bjj {
	background: url(../../assets/img/bjj.png) no-repeat;
	background-size: contain;
	background-position: calc(100% + 12px) calc(100% + 18px);
}
::v-deep {
	> td.text-start:nth-child(2) {
		padding-left: 0;
		padding-right: 0;
	}
	// td.text-start:nth-child(3) {
	// 	padding-right: 0;
	// }
	.v-data-table__expanded__content {
		box-shadow: none !important;
		.v-data-table {
			background-color: #00000000;
		}
	}
	.v-input__prepend-outer {
		display: none;
	}
	// .v-data-table__expanded__content td:nth-child(1) {
	// 	padding-left: 0;
	// 	padding-right: 0;
	// 	// text-align: center;
	// }
}
</style>
